import { render, staticRenderFns } from "./CommunityQna.vue?vue&type=template&id=15549dee&scoped=true&"
import script from "./CommunityQna.vue?vue&type=script&lang=js&"
export * from "./CommunityQna.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15549dee",
  null
  
)

export default component.exports